import arrowLeftBlue from '../../assets/images/icons/footer/arrow-left-blue.png';
import playIcon from '../../assets/images/icons/footer/play.png';
import scenarioIcon from '../../assets/images/icons/footer/scenario.png';
import sitemapActive from '../../assets/images/icons/footer/sitemap-open.png';
import wifiPassive from '../../assets/images/icons/footer/wifi-close.png';
import cloudPassive from '../../assets/images/icons/footer/cloud-close.png';
import knxPassive from '../../assets/images/icons/footer/knx-close.png';
import groupOpen from '../../assets/images/icons/footer/group-open.png';
import groupClose from '../../assets/images/icons/footer/group-close.png';
import React, {memo, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {ScenarioModel} from '../../store/control/state';
import {onClickHandler} from '../../utils/onclick';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import {useQuestion} from '../../hooks/question';
import {clearUserAction} from '../../store/user/action';
import {removeSession} from '../../utils/session-storage';
import {useRPC} from '../../hooks/rpc';
import {useLocalization} from "../../hooks/localization";

type Props = {
    locked: boolean;
    scenarioModelList: ScenarioModel[];
    onScenarioClick: (scenario: ScenarioModel) => void;
};
const explode = () => {
    throw new Error('kaboom');
};

export const FooterComponent = memo(function FooterComponent(props: Props) {
    const {t} = useLocalization();
    const history = useHistory();
    const question = useQuestion();
    const [rpc] = useRPC();
    const dispatch = useDispatch();
    const userList = useSelector(state => state.control.userList);
    const groupSetting = useSelector(state => state.ui.groupSetting);
    const username = useSelector(state => state.user.username);
    const currentUser = useMemo(() => userList.find((u) => u.username === username), [userList, username]);
    const {locked, scenarioModelList, onScenarioClick} = props;
    const backButton = useSelector(state => state.ui.backButton);
    const location = useLocation();
    const onEditPress = useCallback(() => {
        history.push('/settings/users/edit/' + currentUser.id);
    }, [currentUser, history]);

    const onLoginPress = useCallback(() => {
        history.push('/settings/login');
    }, [history]);

    const onLogoutPress = useCallback(() => {
        question(t('DO_YOU_WANT_TO_LOG_OUT'), () => {
            rpc.doLogout();
            dispatch(clearUserAction());
            removeSession();
            history.push('/login');
            window.location.reload();
        });
    }, [t, dispatch, question, rpc]);


    const onGroupToggle = (status) => {
        rpc.groupScriptCommand(location.pathname.split("/")[2], status)
    }

    // @ts-ignore
    return (
        <div className={'footer' + (locked ? ' blur' : '')}>
            <div className='row'>
                <NavLink className={`button float-left back-button ${!backButton.is_open ? `invisible` : ``}`}
                         to={backButton.to}>
                    <img src={arrowLeftBlue} alt=''/>
                </NavLink>
                {

                    renderIf((username === 'default') && (location.pathname.split("/")[1] !== 'area'))(() =>
                        scenarioModelList.map(scenarioModel => {
                            return (
                                <span
                                    key={`scenario_${scenarioModel.id}`}
                                    className="button float-left scenario-button hidden-scenario"
                                    {...onClickHandler(() => onScenarioClick(scenarioModel))}>
                                <img src={scenarioModel.is_playing ? playIcon : scenarioIcon} alt=''/>
                                <span>{scenarioModel.name}</span>
                            </span>
                            );
                        })
                    )

                }

                {
                    groupSetting.visible && <div className="group-buttons">
                     <span className="button"
                           {...onClickHandler(() => onGroupToggle(true))}>
                                <img src={groupOpen} alt=''/>
                                <span>{t('group_on')}</span>
                     </span>
                        <span className="button"
                              {...onClickHandler(() => onGroupToggle(false))}>
                                <img src={groupClose} alt=''/>
                                <span>{t('group_off')}</span>
                    </span>
                    </div>
                }

                <div className='user-info float-right'>
                    {
                        renderIf(username !== 'default')(() =>
                            <>
                                <div onClick={onEditPress}>
                                    <span className='user-text'>{(username)}</span>
                                </div>
                                <div className='logout-button' onClick={onLogoutPress}>
                                    <span className='user-text color-red'>{t('LOG_OUT')}</span>
                                </div>
                            </>,
                        )
                    }
                    {
                        renderIf(username === 'default' && (history.location.pathname === '/settings' || history.location.pathname === '/developer'))(() =>
                            <div onClick={onLoginPress}>
                                <span className='user-text'>{t('LOGIN')}</span>
                            </div>,
                        )
                    }
                </div>
                {
                    renderIf(!(history.location.pathname === '/settings' || history.location.pathname === '/developer'))(() =>
                        <div className='small-icons float-right invisible' onClick={explode}>
                            <img src={''} alt=''/>
                            <img src={''} alt=''/>
                            <img src={''} alt=''/>
                            <img src={''} alt=''/>
                        </div>,
                    )
                }
            </div>
        </div>
    );
});
